import IWallMetaData from 'components/interfaces/IWallMetaData';

const getDefaultWallMetaData = (identifier = ''): IWallMetaData => ({
  doors: [],
  glassAreas: [],
  identifier,
  name: '',
});

export default getDefaultWallMetaData;
